export const userAccessPolicyConstants = {
  owner: "Owner",
  admin: "Admin",
  accountant: "Accountant",
  developer: "Developer",
};
